import type { SerializedDockview } from 'dockview';

export function getAddedPanels(defaultLayout: SerializedDockview, currentLayout: SerializedDockview) {
  const defaultPanels = new Set(Object.keys(defaultLayout.panels));
  const currentPanels = new Set(Object.keys(currentLayout.panels));
  return [...currentPanels.difference(defaultPanels).values()];
}
